if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.errorMessage = this.closest('.cart-drawer__checkout-buttons, .cart__summary')?.querySelector('.js-cart-terms-error');
      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.handleChange.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        this.showError();
      }
    }

    /**
     * Clears the error when terms are accepted.
     */
    handleChange() {
      if (this.cartTermsCheckbox.checked) {
        this.hideError();
      }
    }

    showError() {
      if (!this.errorMessage) return;
      this.errorMessage.textContent = theme.strings.cartTermsConfirmation;
      this.errorMessage.hidden = false;
    }

    hideError() {
      if (!this.errorMessage) return;
      this.errorMessage.hidden = true;
      this.errorMessage.textContent = '';
    }
  }

  customElements.define('cart-terms', CartTerms);
}
